import { apiClient } from '@/api/core';
import { API_CONFIG } from '@/api/core/apiConfig';
import type { ApiResponse } from '@/api/shared/types';

import type { LC_UpdateSecurityGroupingStatusIn } from '../types';


export class SecurityGroupingStatusService {
  async updateStatus(id: number, enabled: boolean): Promise<ApiResponse<null>> {
    const payload: LC_UpdateSecurityGroupingStatusIn = { enabled };
    const response = await apiClient.patch<null>(
      API_CONFIG.ENDPOINTS.SECURITY_GROUPING.STATUS(id),
      payload,
    );
    return { ...response, data: null };
  }
}

export const securityGroupingStatusService = new SecurityGroupingStatusService();
